import Button from "components/components/Button/Button";
import React from "react";

interface Props {
  rerequestData?: () => void | Promise<void>;
  buttonDataTestId?: string;
}

/**
 * Message for when data fails to load.
 *
 * If a rerequest function is passed then a button to reload the data is shown.
 */
const DataLoadFailedMessage: React.FC<Props> = ({
  rerequestData,
  buttonDataTestId,
}) => (
  <>
    <h2>Data failed to load</h2>
    {rerequestData && (
      <Button
        onClick={rerequestData}
        className="button"
        dataTestId={buttonDataTestId}
        buttonText="Try Again"
      />
    )}
  </>
);

export default DataLoadFailedMessage;
